import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { LinearProgressComponent } from './linear-progress.component';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
  ],
  declarations: [
    SpinnerComponent,
    LinearProgressComponent,
  ],
  exports: [
    SpinnerComponent,
    LinearProgressComponent,
  ],
})
export class ProgressModule {}
